var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-descriptions',{attrs:{"title":"用户信息"}},[_c('el-descriptions-item',{attrs:{"label":"用户名"}},[_vm._v(_vm._s(_vm.userinfo.username))]),_c('el-descriptions-item',{attrs:{"label":"已绑定集团"}},[_vm._v(_vm._s(_vm.userinfo.company))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }